import { DOCUMENT_SETSTATE } from "./HolidayActionType";

const apiConfig = window as any;

const initialState = {
    startv: false,
    indexV: 1,
    intImage:apiConfig.INIT_HOLIDAY_IMAGE_COUNTER,
    intVideo:apiConfig.INIT_HOLIDAY_VIDEO_COUNTER
};

export function HolidayReducer(state = initialState, action: any) {
    switch (action.type) {
        case DOCUMENT_SETSTATE:
            return { ...state, [action.payload.key]: action.payload.value };
        default:
            return state;
    }
}
